import { render } from "./App.vue?vue&type=template&id=6efcefbc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/DownloadCenter/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6efcefbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6efcefbc', __exports__)) {
    api.reload('6efcefbc', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=6efcefbc", () => {
    api.rerender('6efcefbc', render)
  })

}


export default __exports__